import { Link } from "../../../ui-kit/Link/Link";
import { Row } from "../../../ui-kit/Row/Row";
import { Text } from "../../../ui-kit/Text/Text";
import styles from "./Bottom.module.scss";

export const Bottom = () => {
  return (
    <div className={styles.container}>
      <Text small color="white-50">
        Сайт может содержать контент, не предназначенный для лиц младше 18 лет.
      </Text>
      <Row justifyContent="flex-start">
        <Link color="blue" small href="https://t.me/dharma1937" style={{ marginRight: 20 }}>
          Telegram
        </Link>
        <Link color="blue" small href="https://vk.com/dharma_1937">
          ВКонтакте
        </Link>

      </Row>
    </div>
  );
};
